/*
 *   File : left-navigation.js
 *   Author : https://evoqins.com
 *   Description : Left navigation component component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';

// custom components
import Icon from '../Icon/icon';
import { CustomTooltip } from '../Others';

// custom style
import style from "../../Style/Component/navigation.module.scss";

const NAV_ITEMS = [
    {
        id: 1,
        icon_active: 'active-dashboard',
        icon: 'dashboard',
        label: "Dashboard",
        path: "/",
        child_path: [],
        short_name: "Dashboard",
    },
    {
        id: 2,
        icon_active: 'ops-active',
        icon: 'ops',
        label: "OPS Dashboard",
        path: "/ops",
        child_path: ["/ops"],
        short_name: "OPS Dashboard",
    },
    {
        id: 3,
        icon_active: 'active-customers',
        icon: "customers",
        label: "Customers",
        path: "/customers",
        child_path: [`customers`],
        short_name: "Customer",
        short_names: ["Customer", "Bank Verification","User Group"],
    },
    {
        id: 4,
        icon_active: 'active-orders',
        icon: "orders",
        label: "Orders",
        path: "/orders",
        child_path: ["orders", "goal-order-detail", "fund-order-detail"],
        short_name: "Order",
        short_names: ["Order", "Switch/SWP/STP"],
        children: [
            { id: 41, label: "Switch", path: "/other-transactions", tab_index: 1 },
            { id: 42, label: "SWP", path: "/other-transactions", tab_index: 2 },
            { id: 43, label: "STP", path: "/other-transactions", tab_index: 3 },
            { id: 44, label: "NFO", path: "/other-transactions", tab_index: 4 },
        ],
    },
    {
        id: 5,
        icon_active: 'systematic-plan-active',
        icon: "systematic-plan",
        label: "Systematic Plans",
        path: "/sip",
        child_path: ["sip", "swp", "stp"],
        short_name: "SIP",
        short_names: ["SIP"],
        children: [
            { id: 51, label: "SIP", path: "/sip" },
            { id: 52, label: "SWP", path: "/swp" },
            { id: 53, label: "STP", path: "/stp" },
        ],
    },
    {
        id: 6,
        icon_active: 'active-manage-baskets',
        icon: "manage-baskets",
        label: "Manage Baskets",
        path: "/baskets",
        child_path: ["rebalance-history", "manage-basket"],
        short_name: "Manage Basket",
    },
    {
        id: 7,
        icon_active: 'active-risk-assessment',
        icon: "risk-assessment",
        label: "Risk Assessment",
        path: "/risk-assessment",
        child_path: ["/risk-assessment", "/manage-questionnaire"],
        short_name: "Risk Assesment",
    },
    {
        id: 8,
        icon_active: 'active-push-notification',
        icon: "push-notification",
        label: "Push Notification",
        path: "/push-notification",
        child_path: ["/push-notification/manage"],
        short_name: "Push Notification",
    },
    {
        id: 9,
        icon_active: 'active-monthly-report',
        icon: "monthly-report",
        label: "Monthly Reports",
        path: "/monthly-reports",
        child_path: [],
        short_name: "Monthly Reports",
    },

    {
        id: 10,
        icon_active: 'active-revenue',
        icon: "revenue",
        label: "Revenue",
        path: "/revenue",
        child_path: [],
        short_name: "Revenue",
    },
    {
        id: 11,
        icon_active: 'send-email-active',
        icon: "send-email",
        label: "Send Mail",
        path: "/send-mail",
        child_path: ["send-mail"],
        short_name: "Send Mail",
    },
    {
        id: 12,
        icon_active: 'active-leads',
        icon: "leads",
        label: "Leads",
        path: "/leads",
        child_path: ["leads"],
        short_name: "Leads",
    },
    // {
    //     id: 20,
    //     icon_active: 'active-orders',
    //     icon: "orders",
    //     label: "Switch/SWP/STP",
    //     path: "/other-transactions",
    //     child_path: ["other-transactions"],
    //     short_name: "Switch/SWP/STP",
    //     short_names: ["Order", "Switch/SWP/STP"],
    // },
     {
        id: 13,
        icon_active: 'active-banner',
        icon: "inactive-banner",
        label: "Manage banners",
        path: "/manage-banner",
        child_path: [],
        short_name: "Manage Banner",
    },
    {
        id: 14,
        icon_active: 'active-manage-sub-admins',
        icon: "manage-sub-admins",
        label: "Manage Sub Admins",
        path: "/sub-admins",
        child_path: [`sub-admins`],
        short_name: "Manage Sub Admins",
    },
    {
        id: 15,
        icon_active: 'active-document-and-actions',
        icon: "documents-and-actions",
        label: "Documents & Action",
        path: "/documents",
        child_path: ["/documents"],
        short_name: "Document & Actions"
    },
    {
        id: 16,
        icon_active: 'active-prime-data',
        icon: "prime-data",
        label: "Prime Data",
        path: "/prime-data",
        child_path: [],
        short_name: "Prime Data",
    },
    {
        id: 17,
        icon_active: 'active-support-customers',
        icon: "support-customers",
        label: "Support - Customers",
        path: "/support",
        child_path: [`/support`],
        short_name: "Support",
    },
    {
        id: 18,
        icon_active: 'active-non-kyc-nri',
        icon: "non-kyc-nri",
        label: "Non-KYC NRI’s",
        path: "/non-kyc-nri",
        child_path: ["/non-kyc-nri"],
        short_name: "Non-KYC NRI",
    },
    {
        id: 19,
        icon_active: 'active_config',
        icon: "config",
        label: "Config",
        path: "/config",
        child_path: ["/config"],
        short_name: "Config",
    },
    {
        id: 20,
        icon_active: 'fund-scheme-active',
        icon: "fund-scheme-inactive",
        label: "Fund Scheme",
        path: "/fund-scheme",
        child_path: ["/fund-scheme"],
        short_name: "Fund Scheme",
    },
];


const LeftNavigation = (props) => {
    const TOKEN = Cookies.get("access_token");

    const PROFILE_DATA = useSelector((store) => store.Reducer.PROFILE_DATA);

    const navigate = useNavigate();
    const { pathname, state } = useLocation();

    const [navigateItems, setNavigateItems] = useState([]);

    const matchesModule = (item, moduleName = "") => {
        const supportedNames = item.short_names?.length ? item.short_names : [item.short_name];
        return supportedNames.some(name => name.toLowerCase() === moduleName.toLowerCase());
    };

    const isParentPathActive = (navigation) => {
        return navigation.path === pathname || navigation.child_path.some(path => pathname.includes(`${path}`));
    };

    const isOrdersChildPath = (pathname) => pathname.includes("other-transactions");

    const isNavExpanded = (navigation) => navigation.children?.length > 0;

    const isOrdersSectionActive = (navigation) => {
        return isParentPathActive(navigation) || (navigation.children?.length > 0 && isOrdersChildPath(pathname));
    };

    const matchesPath = (path) => pathname === path || pathname.startsWith(`${path}/`);

    const isSystematicPlansSectionActive = (navigation) => {
        return matchesPath(navigation.path) || navigation.children.some(child => matchesPath(child.path));
    };

    const isSectionActive = (navigation) => {
        if (navigation.path === "/orders") {
            return isOrdersSectionActive(navigation);
        }
        if (navigation.path === "/sip" && navigation.children?.length) {
            return isSystematicPlansSectionActive(navigation);
        }
        return isParentPathActive(navigation);
    };

    const getActiveChildTab = () => {
        if (!isOrdersChildPath(pathname)) return null;
        // Default Switch (1) when state was lost (e.g. detail modal history) so a child stays active
        return state?.tab_index ?? 1;
    };

    const isChildActive = (child) => {
        if (child.tab_index != null) {
            return getActiveChildTab() === child.tab_index;
        }
        return matchesPath(child.path);
    };

    // useEffect(() => {
    //     _getProfile();
    // }, []);

    useEffect(() => {
        if (Object.keys(PROFILE_DATA).length !== 0 && Object.keys(PROFILE_DATA?.modules).length) {
            const updated_items = NAV_ITEMS.filter(items =>
                PROFILE_DATA.modules.some(mod => matchesModule(items, mod.name))
            );
            setNavigateItems(updated_items);
        }

    }, [PROFILE_DATA]);

    useEffect(() => {

        if (TOKEN && pathname === "/" && PROFILE_DATA?.modules?.length) {
            const allowedItems = NAV_ITEMS.filter(nav =>
                PROFILE_DATA.modules.some(
                    mod => matchesModule(nav, mod.name)
                )
            );

            if (allowedItems.length) {
                const hasDashboard = allowedItems.some(item => item.short_name.toLowerCase() === "dashboard");
                if (!hasDashboard) {
                    navigate(allowedItems[0].path, { replace: true });
                }
            }
        }
    }, [TOKEN, pathname, PROFILE_DATA, navigate]);

    // handle navigation 
    const _handleNavigate = (path) => {
        navigate(path);
    };

    const _handleChildNavigate = (child) => {
        if (child.disabled) return;
        if (child.tab_index != null) {
            navigate(child.path, {
                state: {
                    tab_index: child.tab_index,
                    current_page: 1,
                },
            });
            return;
        }
        navigate(child.path);
    };

    // API - Notification count

    return (
        <div className={`e-bg-white padding-64px-top pb-3 position-sticky top-0 start-0 min-vh-100 transition`}>
            <div className="e-profile-tag">{PROFILE_DATA?.admin_type}</div>
            {/* <img src={require("../../Assets/Image/tag.png")}
                draggable={false}
                height={32}
                width={110}
                className='position-absolute top-16px right--8px'
                alt='tag' /> */}
            <div className='pb-2 text-center'>
                <img src={require("../../Assets/Image/logo.svg").default}
                    draggable={false}
                    width={props.toggled ? 62 : 82}
                    height={60}
                    className='transition'
                    alt='logo' />
            </div>

            <div className={`${style.e_left_navigation_wrapper} ${props.toggled ? 'px-4 ' : 'px-3'} py-3 d-flex flex-column gap-2 overflow-y-scroll overscroll-behavior-none`}>
                {navigateItems.map((navigation, key) => {
                    const expanded = isNavExpanded(navigation);
                    const showParentActive = isSectionActive(navigation);
                    const lockParentClick = pathname === navigation.path || pathname === `${navigation.path}/`;

                    return (
                        <div key={key} className="d-flex flex-column">
                            <div
                                className={`${lockParentClick ? "pe-none" : ""} ${showParentActive ?
                                    "e-bg-blue-violet" : style.e_inactive} ${props.toggled ? 'justify-content-center ' : ''} cursor-pointer  ${props.toggled ? 'padding-30px-lr padding-6px-tb' : 'padding-12px-lr py-2'} d-flex gap-2 align-items-center border-radius-8 transition`}
                                onClick={() => _handleNavigate(navigation.path)}>
                                {showParentActive ?
                                    <>
                                        <Icon icon={navigation.icon_active}
                                            size={22} />
                                    </>
                                    :
                                    <>
                                        <Icon icon={navigation.icon}
                                            size={22} />
                                    </>
                                }

                                {props.toggled === false ?
                                    <p className={`${showParentActive ?
                                        "e-text-white" : "e-text-charleston-green-light"} mb-0 e-primary-font e-font-16 e-font-weight-600 line-height-20px`}>
                                        {navigation.label}
                                    </p>
                                    :

                                    <CustomTooltip content={navigation.label}
                                        id={`tooltip-${navigation.id}`} />
                                }

                            </div>

                            {expanded && !props.toggled &&
                                <div className={style.e_submenu}>
                                    {navigation.children.map((child) => {
                                        const childActive = isChildActive(child);

                                        return (
                                            <div
                                                key={child.id}
                                                className={`${style.e_submenu_item} ${childActive ? style.e_submenu_item_active : ""} ${child.disabled ? style.e_submenu_item_disabled : ""}`}
                                                onClick={() => _handleChildNavigate(child)}>
                                                <p className="mb-0 e-primary-font e-font-14 e-font-weight-400 line-height-16px e-text-chinese-black">
                                                    {child.label}
                                                </p>
                                            </div>
                                        );
                                    })}
                                </div>
                            }
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default LeftNavigation;
